import apiMethods from '@/api/http'
var http = apiMethods.methods
// const HostCompany = constGlobal.HostCompany
const HostCompany = process.env.NODE_ENV == 'development' ? '/api' : ''
// const HostCompany = process.env.NODE_ENV == 'development' 
//   ? '/api' 
//   : process.env.VUE_APP_API_URL;
// console.log(HostCompany);

// const HostCompany = '/api'
const pubResApi = {
  /**
  * @method 查询首页数据
  */
    getCount: () => http.apiGet(HostCompany + '/yjcx/index/index'),
    getjgCount: () => http.apiPost(HostCompany + '/yjcx/dlindex/index'),
  /**
  * @method 查询公司列表
  */
    getCompany: (params) => http.apiGet(HostCompany + '/yjcx/index/search', params),
    getjgCompany: (params) => http.apiPost(HostCompany + '/yjcx/dlindex/search', params),

  /**
   * @method 查询哪一年有数据
   */
    getYear: (id) => http.apiGet(HostCompany + 'companyBidLastDate/search?uniscid=' + id),
  /**
   * @method 查询公司详情
  */
    // getCompanyDetail: (id) => http.apiGet(HostCompany + '/yjcx/index/show/uniscid/' + id),
    getCompanyDetail: (params) => http.apiGet(HostCompany + '/yjcx/index/show', params, {
      'Content-Type': 'application/x-www-form-urlencoded'
    }),
  /**
  * @method 查询公司中标项目列表
  */
    getCompanyProject: (params) => http.apiGet(HostCompany + '/yjcx/index/bid_list', params, {
      'Content-Type': 'application/x-www-form-urlencoded'
    }),
    // getjgCompanyProject: (params) => http.apiPost(HostCompany + '/yjcx/dlindex/bid_list', params),
    getjgCompanyProject: (params) => http.apiPost(HostCompany + '/yjcx/dlindex/bid_list_new', params), // 去除行业

  /**
  * @method 获取项目详情
  */
    getProject: (params) => http.apiGet(HostCompany + '/yjcx/index/bid_show', params, {
      'Content-Type': 'application/x-www-form-urlencoded'
    }),
  /**
  * @method 获取项目详情
  */
    getRank: (params) => http.apiGet(HostCompany + '/yjcx/index/new_lh_hit', params),
    // getjgRank: (params) => http.apiPost(HostCompany + '/yjcx/dlindex/lh_hit', params),
    getjgRank: (params) => http.apiPost(HostCompany + '/yjcx/dlindex/lh_hit_new', params), // 去除行业

  /**
  * @method 发布留言
  */
    submitMessage: (params) => http.apiPost(HostCompany + '/yjcx/index/publish_message', params),
  /**
  * @method 企业资质查询
  */
    getQualient: (params) => http.apiGet(HostCompany + '/yjcx/index/qualient', params),
  /**
 * @method 企业信用查询
 */
    getCredit: (params) => http.apiGet(HostCompany + '/yjcx/index/searchDateTypeCount', params),

  /**
* @method 企业信用查询
*/
    getSearchDateCategoryCount: (params) => http.apiGet(HostCompany + '/yjcx/index/searchDateCategoryCount', params),

    keep_info: (params) => http.apiGet(HostCompany + '/yjcx/index/keep_info', params, {
      'Content-Type': 'application/x-www-form-urlencoded'
    }),
    black_list_info: (params) => http.apiGet(HostCompany + '/yjcx/index/black_list_info', params)

}
export default pubResApi
